export default "__VITE_ASSET__Bq2n3YpA__"